import React, { useContext, useEffect, useState } from "react";
import axios from "axios";
import login from "../services/login";
import { AuthContext } from "../AuthContext";
import { useNavigate } from "react-router-dom";
import { addToken, getApi } from "@beeldit/core/helpers/api";
import AuthInterceptor from "../interceptors/AuthInterceptor";
import { t } from "i18next";

let interceptorId: number | null = null;

interface Prop {
  redirectUrls?: any;
}

const Login = (props: Prop) => {
  const { redirectUrls } = props;
  const logoName = process.env.REACT_APP_LOGO_NAME;
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const { setToken, setUser } = useContext(AuthContext);

  useEffect(() => {
    setToken(null);
    setUser(null);
    localStorage.removeItem("token");
    localStorage.removeItem("user");
  }, []);

  const navigate = useNavigate();

  const onSuccess = (data: any) => {
    const token = data.token;
    const user = data.user;
    localStorage.setItem("token", token);
    localStorage.setItem("user", JSON.stringify(user));
    setToken(JSON.stringify(token));
    setUser(user);
    const authInterceptor = AuthInterceptor(() => token);
    addToken(token);    
    let url = "/panel";
    let role = data.user.role;
    if(redirectUrls && redirectUrls[role]) {
      url = redirectUrls[role];
    }
    navigate(url);
  };

  const handleLogin = async (e: any) => {
    login({ email: email, password: password }, onSuccess);
  };

  const handleKeyPress = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === "Enter") {
      event.preventDefault();
      handleLogin(event);
    }
  };

  return (
    <div
      className="d-flex flex-column align-items-center justify-content-center"
      style={{ minHeight: "100vh" }}
    >
      <img
        src={logoName}
        alt="App Icon"
        style={{ maxWidth: "10%", height: "auto", marginBottom: "3rem" }}
      />
      <div className="card" style={{ width: "18rem" }}>
        <div className="card-body">
          <h5 className="card-title text-center mb-4">{t("sign_in")}</h5>
          <form>
            <div className="mb-3">
              <label htmlFor="username" className="form-label">
                {t("email")}:
              </label>
              <input
                type="text"
                className="form-control"
                id="username"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                onKeyPress={handleKeyPress}
              />
            </div>
            <div className="mb-3">
              <label htmlFor="password" className="form-label">
                {t("password")}:
              </label>
              <input
                type="password"
                className="form-control"
                id="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                onKeyPress={handleKeyPress}
              />
            </div>
            <button
              onClick={handleLogin}
              type="button"
              className="btn btn-primary w-100"
            >
              {t("sign_in")}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Login;
